export default (request) => ({
  signIn: (data, options = {}) => request({
    method: 'post',
    url: '/clients/auth/login',
    data,
    ...options,
  }),

  requestPasswordReset: (data, options = {}) => request({
    method: 'post',
    url: '/clients/password/forgot',
    data,
    ...options,
  }),

  resetPassword: (data, options = {}) => request({
    method: 'post',
    url: '/clients/password/reset',
    data,
    ...options,
  }),
});
